<nz-layout>
  <nz-header class="section-header">
    {{'Medical Problems'|translate}}
  </nz-header>
  <nz-content>
    @for (cm of submenu; track cm) {
      @if (cm.path==componentPaths.currentProblems) {
        <app-current-problems [id]="cm.path" />
      }
      @if (cm.path==componentPaths.devicesAndImplants) {
        <app-medical-device [id]="cm.path" />
      }
      @if (cm.path==componentPaths.procedures) {
        <app-procedure [id]="cm.path" />
      }
    }
  </nz-content>
</nz-layout>